import axios from 'axios';
import intlTelInput from 'intl-tel-input';

const COUNTRY_API_URL = 'https://api.country.is/';
const DEFAULT_COUNTRY = 'br';
const TIMEOUT_IN_MS = 3000;

export default class CountryService {
  // Sempre devolve um país conhecido pelo intl-tel-input: com país vazio ou inválido o campo fica sem DDI
  public static async getCountryByIp(): Promise<string> {
    try {
      const { data } = await axios.get<{ country?: string }>(COUNTRY_API_URL, { timeout: TIMEOUT_IN_MS });
      const country = data.country?.toLowerCase();
      return this.isKnownCountry(country) ? country : DEFAULT_COUNTRY;
    } catch {
      return DEFAULT_COUNTRY;
    }
  }

  private static isKnownCountry(country?: string): country is string {
    return intlTelInput.getCountryData().some((item) => item.iso2 === country);
  }
}
